import { render, staticRenderFns } from "./QuestionNaireAdminister.vue?vue&type=template&id=013a1f89&"
import script from "./QuestionNaireAdminister.vue?vue&type=script&lang=js&"
export * from "./QuestionNaireAdminister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports